<template>
  <div class="messages">
    <vs-col
      v-for="item in messages"
      :key="item.id"
      class="message-item"
      v-bind:style="
        item.sent_by_operator
          ? 'borderRightColor: #FFA319;'
          : 'borderRightColor: #33C2FF;'
      "
    >
      <div class="header">
        <h6>{{ renderTitle(item) }}</h6>
        <p>{{ getLastTimeUpdated(item.updated_at) }}</p>
      </div>
      <div v-html="item.content" class="content" />
      <div
        v-if="item.attachments && item.attachments.length > 0"
        class="footer"
      >
        <h6>{{ "ضمیمه ها" }} ( {{ item.attachments.length }} )</h6>
        <p
          v-for="attachment in item.attachments"
          :key="attachment.id"
          class="attachment"
          @click="downloadAttachment(attachment)"
        >
          {{ attachment.name + getAttachmentType(attachment) }}
        </p>
      </div>
    </vs-col>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  convertDateToHumanReadable,
  downloadFile,
  getMimeType,
} from "../../../helpers/Functions";

export default {
  name: "Messages.vue",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    getLastTimeUpdated(value) {
      return convertDateToHumanReadable(value, true);
    },
    getAttachmentType(attachment) {
      return getMimeType(attachment);
    },
    downloadAttachment(attachment) {
      downloadFile(attachment);
    },
    renderTitle(item) {
      const userName = item.user?.name;

      /**
       * This label will be added if the message is sent by operator
       */
      if (item.sent_by_operator) {
        return userName + " | " + "پشتیبان فنی";
      }

      return userName;
    },
  },
  props: {
    messages: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.messages {
  flex: 1;

  .message-item {
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 1px rgba(var(--vs-primary), 0.15);
    display: flex;
    flex-direction: column;
    margin-bottom: 25px;
    padding: 0;
    border-left: 5px solid;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px;
      border-bottom: 1px solid rgba(203, 204, 210, 0.5);

      h6 {
        margin-bottom: 5px;
      }
    }

    .content {
      padding: 15px;

      ul {
        list-style-type: inherit;
        padding: 10px 20px;
      }

      ol {
        list-style-type: decimal;
        padding: 10px 20px;
      }
    }

    .footer {
      padding: 15px;
      border-top: 1px solid rgba(203, 204, 210, 0.5);

      .attachment {
        direction: rtl;
        text-align: left;
        margin-top: 10px;
        color: blue;
        cursor: pointer;
      }
    }
  }
}
</style>

